import React from 'react'
import {
  AlignItems,
  Box,
  Display,
  FlexDirection,
  Heading1,
  JustifyContent,
} from '@gousto-internal/citrus-react'

import { useDashboardExperience } from './hooks/useDashboardExperience'
import { Notification } from './components/Notification'

export function MyHomePage() {
  const { page_title, error } = useDashboardExperience()

  return (
    <main data-testid="my-home-page-main">
      <Box
        width="100%"
        maxWidth="1200px"
        style={{ margin: '0 auto' }}
        display={Display.Flex}
        flexDirection={FlexDirection.Column}
        alignItems={AlignItems.FlexStart}
        gap={[4, 6]}
        paddingV={[4, 6]}
        paddingH={[3, 0]}
      >
        <Box
          width="100%"
          minHeight={['52px', '40px']}
          display={Display.Flex}
          alignItems={AlignItems.Center}
          justifyContent={JustifyContent.FlexStart}
          paddingV={[3, 1]}
          paddingH={[3, 0]}
          data-testid="my-home-page-title-box"
        >
          {error ? (
            <Notification
              state="error"
              message="Oops something went wrong. Please try again later."
            />
          ) : (
            <Heading1>{page_title}</Heading1>
          )}
        </Box>
      </Box>
    </main>
  )
}
